// extracted by mini-css-extract-plugin
export default {"second":"second_second__Peu-1","next-gen":"second_next-gen__FmoAd","next-gen-text":"second_next-gen-text__4103A","img":"second_img__ZPsFG"};